function ContentCategoryPost({
  search,
  list,
  checkedControl,
  handleChecked,
  categorytList,
  setEditData,
}: any) {
  function getParentNamess(item: any) {
    const hiyersiMapIds = item?.hiyerarsiMap.split('|')
    let z = ''

    hiyersiMapIds?.map((element: any) => {
      let parent: any = []
      parent = categorytList.filter((i: any) => i.id === Number(element))
      if (parent[0]) {
        if (z === '') {
          z = parent[0].nodeAd
        } else {
          z += '|' + parent[0].nodeAd
        }
      }
    })
    return String(z + '|' + item.nodeAd)
  }

  return search(list)?.map((item: any, index: any) => (
    <tr key={index}>
      <td>
        <input
          className='form-check-input'
          type='checkbox'
          value={index}
          checked={checkedControl(String(index))}
          onChange={(e) => (handleChecked(e, item), setEditData(item))}
        />
      </td>
      <td>{item.categoryId}</td>
      <td>
        <span>{getParentNamess(item)}</span>
      </td>
    </tr>
  ))
}

export default ContentCategoryPost
